import { gql } from '@apollo/client';

export const GET_USER_INFO = gql`query userInfo {
    remote_control {
        id
        username
        avatar_url
        organizations {
            id name
        }
        roles
    }
}`;
